import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames/bind'
import CajaDecorator from 'decorators/caja/caja_decorator'
import styles from './select_button.scss'

const selectArrow = <svg height="5px" id="SvgjsSvg1000" width="8px" version="1.1" viewBox="0 0 8 5" x="0px" y="0px" xmlSpace="preserve"> <path className="select_button__button_icon_svgpath" d="M0,0h8L4,5L0,0z" fill="#B8C0C6"/> </svg>

class SelectButton extends Component {

	render() {
		// FRONT-END 'selected' class should be applies when the user chooses an option
		const cx = classNames.bind(styles)
		const classValue = cx({
			button: true,
			'button-form': this.props.fontSize === 'medium',
			'button-big': this.props.fontSize === 'big',
			'button--active': this.props.active,
			'button--selected': this.props.selected,
			disabled: this.props.disabled,
		})

		return (
			<div className={styles.wrapper}>
				<div
					className={classValue}
					tabIndex={this.props.tabIndex}
					onBlur={this.props.onBlur}
					onClick={this.props.onClick}
					onFocus={this.props.onFocus} >
					<span className={styles.button_text}>
						{ this.props.text }
					</span>
					<i className={styles.button_icon}>
						{ selectArrow }
					</i>
				</div>
			</div>
		)
	}
}

SelectButton.defaultProps = {
	tabIndex: 0,
	fontSize: 'small',
}

SelectButton.propTypes = {
	className: PropTypes.string,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onClick: PropTypes.func,
	tabIndex: PropTypes.number,
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
}

export default CajaDecorator(SelectButton)
